import { useCallback, useEffect, useState } from 'react';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { Label } from '@/components/ui/label';
import { useNavigate } from 'react-router-dom';
import { useAuthenticationContext } from '../authentication.context';
import AuthenticationService from '@/lib/auth';
import authenticationServiceApi from 'shared/api/authentication.service.api';
import { Loader } from '@/components/loader/loader';

export default function Verify() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { userId } = useAuthenticationContext();

  const verify = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await authenticationServiceApi.verifyCode({ userId, code });

      if (error) throw new Error(error);

      AuthenticationService.authenticate(data);
      navigate('/dashboard/organizations');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [userId, code, navigate]);

  useEffect(() => {
    if (code.length !== 6) return;
    verify();
  }, [code, verify]);

  return (
    <>
      <Label className="mb-6">Enter the 6-digit code sent to your email</Label>
      {loading ? (
        <div className="w-[500px] flex justify-center">
          <Loader />
        </div>
      ) : (
        <InputOTP maxLength={6} pattern={REGEXP_ONLY_DIGITS} onChange={setCode} autoFocus>
          <InputOTPGroup className="w-[500px]">
            {[...Array(6)].map((_, index) => (
              <InputOTPSlot key={index} index={index} className="w-[60px] h-[60px]" />
            ))}
          </InputOTPGroup>
        </InputOTP>
      )}
      {error && <Label className="ml-2 text-red-500">{error}</Label>}
    </>
  );
}
